var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "22 24 262 334.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_2244)",
    filter: "url(#filter0_dd_0_2244)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 334.468,
    transform: "translate(22 24)",
    fill: "#FF896F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24,
    width: 262,
    height: 334.468,
    fill: "#FFD5CC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284 24L22 24L22 358.468H284V24ZM58.0026 37.9361C44.1485 37.9361 32.9175 49.167 32.9175 63.0212V319.447C32.9175 333.301 44.1486 344.532 58.0027 344.532H247.999C261.853 344.532 273.084 333.301 273.084 319.447V63.0212C273.084 49.167 261.853 37.9361 247.999 37.9361H58.0026Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.602 181.443C214.128 203.975 202.706 237.658 173.556 251.395C166.23 254.848 162.158 251.497 153.322 251.923C145.427 252.304 142.989 255.088 135.469 252.396C104.245 241.217 90.3809 208.47 89.817 184.336C89.0798 152.783 114.89 136.114 151.098 156.704C183.952 135.691 212.865 149.891 213.602 181.443Z",
    fill: "#FF542F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.946 150.519C133.034 141.101 116.607 139.873 104.177 146.195C90.9668 152.915 84.0641 167.237 84.4666 184.461C85.0624 209.963 99.659 245.26 133.666 257.436C138.365 259.119 141.777 259.132 145.105 258.598C146.248 258.414 147.181 258.221 148.058 258.039C149.741 257.691 151.219 257.384 153.581 257.271C156.389 257.135 158.41 257.425 160.708 257.754C161.548 257.874 162.424 258 163.389 258.112C167.035 258.535 170.978 258.529 175.839 256.238C207.566 241.286 219.511 205.124 218.955 181.319C218.547 163.854 210.204 150.277 196.493 144.437C183.664 138.973 167.43 140.831 150.946 150.519ZM173.557 251.395C202.707 237.658 214.13 203.975 213.603 181.444C212.866 149.891 183.953 135.692 151.099 156.704C114.891 136.114 89.0811 152.783 89.8183 184.336C90.3821 208.471 104.246 241.217 135.471 252.396C140.353 254.144 143.093 253.584 146.575 252.871C148.457 252.486 150.555 252.057 153.324 251.924C156.684 251.762 159.355 252.146 161.778 252.494C165.726 253.062 169.017 253.535 173.557 251.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.652 237.108C190.802 223.37 199.844 189.687 199.317 167.156C199.163 160.558 197.777 154.718 195.38 149.801C206.247 154.896 213.246 166.124 213.604 181.443C214.131 203.974 202.708 237.657 173.558 251.394C169.018 253.534 165.728 253.061 161.779 252.493C159.356 252.145 156.685 251.761 153.325 251.923C150.556 252.056 148.458 252.485 146.577 252.87C143.094 253.583 140.354 254.143 135.472 252.396C124.051 248.307 114.953 241.332 107.979 232.95C111.289 234.969 114.891 236.708 118.804 238.109C123.839 239.912 127.664 239.259 132.013 238.516C134.158 238.15 136.43 237.762 139.038 237.636C142.312 237.478 145.259 237.839 148.045 238.18C152.776 238.759 157.041 239.281 161.652 237.108Z",
    fill: "#ED4A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.837 175.52C195.474 178.125 193.067 179.942 190.462 179.579C187.858 179.215 186.04 176.809 186.404 174.204C186.767 171.599 189.173 169.782 191.778 170.146C194.383 170.509 196.2 172.915 195.837 175.52Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.725 189.307C208.362 191.912 205.956 193.729 203.351 193.366C200.746 193.003 198.929 190.596 199.292 187.991C199.656 185.387 202.062 183.569 204.667 183.933C207.272 184.296 209.089 186.703 208.725 189.307Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.451 171.269C208.179 173.223 206.374 174.586 204.42 174.313C202.467 174.041 201.104 172.236 201.376 170.282C201.649 168.329 203.454 166.966 205.407 167.238C207.361 167.511 208.724 169.316 208.451 171.269Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.042 205.871C203.679 208.475 201.273 210.293 198.668 209.929C196.063 209.566 194.246 207.159 194.609 204.555C194.973 201.95 197.379 200.133 199.984 200.496C202.589 200.859 204.406 203.266 204.042 205.871Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.153 192.083C190.79 194.688 188.384 196.505 185.779 196.142C183.174 195.779 181.357 193.372 181.72 190.767C182.084 188.162 184.49 186.345 187.095 186.709C189.7 187.072 191.517 189.478 191.153 192.083Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.183 223.925C195.819 226.53 193.413 228.347 190.808 227.984C188.203 227.621 186.386 225.214 186.75 222.609C187.113 220.005 189.519 218.187 192.124 218.551C194.729 218.914 196.546 221.32 196.183 223.925Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.615 209.489C186.252 212.094 183.845 213.911 181.24 213.547C178.636 213.184 176.818 210.778 177.182 208.173C177.545 205.568 179.952 203.751 182.556 204.114C185.161 204.478 186.978 206.884 186.615 209.489Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.742 234.496C186.47 236.45 184.665 237.812 182.711 237.54C180.758 237.267 179.395 235.463 179.667 233.509C179.94 231.555 181.745 230.192 183.698 230.465C185.652 230.738 187.015 232.542 186.742 234.496Z",
    fill: "#C53622"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.814 107.957C177.814 107.957 183.104 129.772 177.533 141.649C170.819 155.963 150.542 156.867 150.542 156.867C150.542 156.867 144.403 140.133 152.516 125.583C158.757 114.39 177.814 107.957 177.814 107.957Z",
    fill: "#7CD623"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.016 106.696L177.814 107.957L176.101 102.885C177.524 102.405 179.082 102.544 180.397 103.269C181.712 103.993 182.662 105.237 183.016 106.696ZM172.782 109.977C175.761 108.65 177.814 107.957 177.814 107.957C177.814 107.957 178.319 110.041 178.853 113.272C180.046 120.493 181.382 133.443 177.533 141.649C170.819 155.963 150.542 156.867 150.542 156.867C150.542 156.867 144.403 140.134 152.516 125.583C156.708 118.064 166.685 112.693 172.782 109.977ZM150.542 156.867C145.516 158.711 145.516 158.709 145.515 158.707L145.51 158.694L145.502 158.671L145.479 158.606C145.46 158.554 145.437 158.486 145.408 158.403C145.351 158.236 145.275 158.006 145.185 157.718C145.005 157.142 144.768 156.331 144.516 155.323C144.014 153.312 143.443 150.482 143.153 147.144C142.58 140.53 143.078 131.517 147.84 122.976C151.741 115.981 159.232 110.97 164.953 107.868C167.93 106.253 170.685 105.02 172.695 104.19C173.704 103.773 174.534 103.454 175.121 103.237C175.415 103.128 175.649 103.044 175.815 102.985C175.898 102.956 175.964 102.933 176.012 102.916L176.07 102.896L176.096 102.887L176.101 102.885C176.103 102.885 176.101 102.885 177.814 107.957C183.016 106.696 183.016 106.695 183.016 106.696L183.019 106.707L183.023 106.727L183.038 106.789L183.089 107.006C183.131 107.191 183.19 107.454 183.263 107.788C183.407 108.456 183.603 109.41 183.819 110.586C184.249 112.932 184.763 116.197 185.094 119.868C185.73 126.909 185.818 136.592 182.38 143.922C178.128 152.987 169.757 157.473 163.248 159.693C159.923 160.827 156.859 161.451 154.629 161.793C153.508 161.966 152.583 162.069 151.921 162.131C151.59 162.161 151.324 162.182 151.131 162.195C151.035 162.201 150.957 162.206 150.898 162.209L150.824 162.213L150.799 162.214L150.789 162.215L150.784 162.215C150.782 162.215 150.78 162.215 150.542 156.867ZM145.516 158.711L150.542 156.867L150.78 162.215C148.45 162.319 146.32 160.901 145.516 158.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.947 141.73C178.947 132.763 176.005 114.526 176.005 114.526C161.143 129.966 157.402 147.12 156.553 153.315C156.553 153.315 168.947 150.697 173.947 141.73Z",
    fill: "#6FC21C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.61 133.161C127.756 134.391 144.818 148.908 149.601 157.948C150 158.702 152.059 157.522 151.72 156.861C148.992 148.251 140.292 127.928 133.296 121.803C124.08 121.609 122.32 131.224 122.61 133.161Z",
    fill: "#943D31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.366 138.368C119.242 137.86 117.639 136.113 117.316 133.953C117.1 132.511 117.312 130.794 117.644 129.346C118.012 127.74 118.674 125.824 119.785 123.951C122.112 120.029 126.486 116.305 133.409 116.451C134.667 116.477 135.875 116.946 136.822 117.775C139.148 119.812 141.329 122.74 143.262 125.784C145.242 128.903 147.166 132.472 148.916 136.046C152.343 143.041 155.262 150.383 156.744 154.997C157.844 157.816 156.271 160.124 155.788 160.736C155.066 161.648 154.192 162.26 153.491 162.64C152.804 163.013 151.749 163.454 150.476 163.532C149.254 163.607 146.387 163.319 144.87 160.452C142.948 156.82 138.098 151.456 132.678 146.62C130.047 144.273 127.449 142.199 125.26 140.67C124.164 139.904 123.224 139.313 122.473 138.9C121.793 138.526 121.446 138.398 121.375 138.372C121.36 138.366 121.357 138.365 121.366 138.368ZM151.72 156.861C151.717 156.852 151.714 156.842 151.711 156.832C151.348 155.689 150.881 154.342 150.328 152.851C149.624 150.956 148.782 148.829 147.836 146.592C143.902 137.289 138.183 126.081 133.296 121.803C124.08 121.609 122.32 131.224 122.61 133.161C126.32 134.048 136.223 141.84 143.254 149.508C144.742 151.131 146.101 152.748 147.246 154.293C148.097 155.442 148.83 156.551 149.409 157.593C149.475 157.713 149.539 157.831 149.601 157.948C150 158.702 152.059 157.522 151.72 156.861ZM146.57 158.331C146.66 158.646 146.786 158.971 146.957 159.304C146.821 159.039 146.707 158.762 146.617 158.478C146.602 158.429 146.586 158.381 146.57 158.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.078 121.981C136.76 123.775 135.588 127.605 132.462 130.536C129.335 133.466 125.438 134.388 123.756 132.594C122.075 130.801 123.246 126.971 126.373 124.04C129.499 121.109 133.397 120.188 135.078 121.981Z",
    fill: "#C26649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.704 156.878C132.784 160.363 134.286 171.796 129.06 182.415C123.833 193.034 113.857 198.818 106.778 195.334C99.6986 191.849 98.1964 180.416 103.423 169.797C108.649 159.178 118.625 153.394 125.704 156.878Z",
    fill: "#FF896F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.508 165.401C119.779 167.295 120.084 170.671 118.19 172.941C116.957 174.419 116.15 175.98 115.701 177.65C114.933 180.505 111.996 182.197 109.141 181.429C106.286 180.661 104.594 177.724 105.362 174.869C106.233 171.631 107.791 168.693 109.969 166.083C111.862 163.813 115.238 163.507 117.508 165.401Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_0_2244",
    x: 0,
    y: 0,
    width: 304,
    height: 378.468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_2244"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_2244",
    result: "effect2_dropShadow_0_2244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_2244",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_2244",
    x: 18.2837,
    y: 20.2837,
    width: 271.291,
    height: 343.759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.929078,
    dy: 0.929078
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3227
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_2244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_2244",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_2244",
    x: 76.4112,
    y: 98.872,
    width: 176.44,
    height: 198.221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.9194,
    dy: 17.2258
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.479
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.993115 0 0 0 0 0.743134 0 0 0 0 0.689567 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_2244"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_2244",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 334.468,
    fill: "white",
    transform: "translate(22 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLeft);
export default __webpack_public_path__ + "static/media/apple-left.a0659da17a2b9f7400ae5e131200fd95.svg";
export { ForwardRef as ReactComponent };